<div class="mt-1em mb-1em" [formGroup]="formGroup">
  <input
    [type]="type"
    class="hub-input"
    [attr.id]="controlId || null"
    [formControlName]="controlName"
    [attr.aria-invalid]="hasVisibleError ? 'true' : null"
    [attr.aria-describedby]="hasVisibleError ? errorId : null"
    [placeholder]="placeholder || label"
    [maxlength]="maxLength || null"
    (keyup)="onKeyup($event)"
    [attr.autocomplete]="autocomplete"
    [required]="required"
  />

  <!--
    Les messages sont regroupes sous UN identifiant, cible de
    `aria-describedby` : un lecteur d'ecran lit alors l'erreur en arrivant sur
    le champ. `role="alert"` la fait annoncer des son apparition, sans attendre
    que l'utilisateur y revienne (RGAA 11.10).

    Le conteneur n'existe que s'il y a une erreur : present en permanence et
    vide, `role="alert"` declencherait une annonce a chaque changement.
  -->
  @if (hasVisibleError) {
    <div [attr.id]="errorId" role="alert">
      @if (getControlErrors()?.['required'] && submitted) {
        <div class="hub-field__error">
          {{ 'FORM.REQUIRED' | translate }}
        </div>
      }
      @if (getControlErrors()?.['maxlength']) {
        <div class="hub-field__error">
          {{ 'FORM.MAXLENGTH' | translate }}
          {{ getControlErrors()?.['maxlength'].requiredLength }}
          {{ 'FORM.CHARACTERS' | translate }}
        </div>
      }
      @if (getControlErrors()?.['minlength']) {
        <div class="hub-field__error">
          {{
            'FORM.MINLENGTH'
              | translate
                : { min: getControlErrors()?.['minlength'].requiredLength }
          }}
        </div>
      }
      @if (getControlErrors()?.['email']) {
        <div class="danger mt-1em">
          {{ 'FORM.ERROR.NOT_CONFORM.EMAIL' | translate }}
        </div>
      }
      @if (getControlErrors()?.['emailExists']) {
        <div class="hub-field__error">
          {{ 'FORM.ERROR.EMAIL_EXISTS' | translate }}
        </div>
      }
      @if (getControlErrors()?.['passwordStrength']) {
        <div class="hub-field__error">
          {{ 'FORM.ERROR.PASSWORD_NOT_STRONG_ENOUGH' | translate }}
        </div>
      }
      @if (getControlErrors()?.['serverErrors']) {
        @for (error of getControlErrors()?.['serverErrors']; track error) {
          <div class="hub-field__error">
            {{ error }}
          </div>
        }
      }
      @if (getControlErrors()?.['nameTaken']) {
        <div class="hub-field__error">
          {{ 'FORM.ERROR.NAME_TAKEN' | translate }}
        </div>
      }
      @if (isPatternInvalid) {
        <div class="hub-field__error">
          {{
            'FORM.REGEX_LIMIT'
              | translate
                : { min: getRegexLimit()?.min, max: getRegexLimit()?.max }
          }}
        </div>
      }
    </div>
  }
</div>
